import request from '@/shared/api/request';

export const markNotificationAsRead = (id: number): Promise<unknown> =>
  request({
    url: `/notifications/${id}/show/`,
  });
